import t from '@rcm/i18n-client';
import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import useResultsQueries from '../../hooks/useResultsQueries';
import { selectView } from '../../slices/view';
import { ViewID } from '../../types';
import CloseButton from '../shared/CloseButton';
import OrderNowButton from './OrderNowButton';
import Errors from '../shared/Errors';
import LoadingSpinner from '../shared/LoadingSpinner';

const CalculationResults = () => {
    const view = useSelector(selectView);
    const resultsQueries = useResultsQueries();

    return <Modal show={view === ViewID.RESULTS} onHide={noop}>
        <Modal.Body>{
            resultsQueries.isFetching ?
                <LoadingSpinner text={t('Calculating...')} /> :
            resultsQueries.isError ?
                <Errors error={resultsQueries.error} /> :
            <>
                <Table borderless>
                    <tbody>
                        <tr>
                            <th>{t('Item')}</th>
                            <th className="text-end">{t('Qty')}</th>
                        </tr>
                        {resultsQueries.data?.skuLines.map(([skuName, qty]) => <tr key={skuName}>
                            <td>{skuName}</td>
                            <td className="text-end">{qty}</td>
                        </tr>)}
                    </tbody>
                </Table>
                <Table borderless>
                    <tbody>
                        <tr>
                            <td className="pt-4 border-top border-top-1 border-dark">
                                {t('PV Total')}
                            </td>
                            <td className="pt-4 border-top border-top-1 border-dark text-end">
                                {resultsQueries.data?.data?.formatted?.pvSubTotal}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('Subtotal')}</th>
                            <th className="text-end">{resultsQueries.data?.data?.formatted?.subTotal}</th>
                        </tr>
                        {(resultsQueries.data?.data?.discount != 0) && <tr>
                            <td>{t('Discounts')}</td>
                            <td className="text-end">{resultsQueries.data?.data?.formatted?.discount}</td>
                        </tr>}
                        <tr>
                            <td>{t('Tax')}</td>
                            <td className="text-end">{resultsQueries.data?.data?.formatted?.tax}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">{t('Shipping')}</td>
                            <td className="pb-4 text-end">{resultsQueries.data?.data?.formatted?.shipping}</td>
                        </tr>
                        <tr>
                            <th className="border-top border-top-1 border-dark fs-4">
                                {t('Total')}
                            </th>
                            <th className="border-top border-top-1 border-dark text-end fs-4">
                                {resultsQueries.data?.data?.formatted?.total}
                            </th>
                        </tr>
                    </tbody>
                </Table>
            </>
        }</Modal.Body>
        <Modal.Footer>
            <OrderNowButton />
            <CloseButton />
        </Modal.Footer>
    </Modal>;
}

export default CalculationResults;

